
import state from './moduleVerticalManagementState'
import mutations from './moduleVerticalManagementMutations'
import actions from './moduleVerticalManagementActions'
import getters from './moduleVerticalManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

